import { render } from "./v-col.vue?vue&type=template&id=a61f5de4&scoped=true"
import script from "./v-col.vue?vue&type=script&lang=js"
export * from "./v-col.vue?vue&type=script&lang=js"

import "./v-col.vue?vue&type=style&index=0&id=a61f5de4&scoped=true&lang=css"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a61f5de4"]])

export default __exports__